import React from 'react'
import ExportClientWorkflow from '../features/workflows-page/exportClientWorkflow/ExportClientWorkflow'


function ClientWorkFlow() {
  return (
    <><ExportClientWorkflow /></>
  )
}

export default ClientWorkFlow